import { FC } from 'react';

import { FormFooter } from 'modules/settings/common/components';
import { SettingsView } from 'modules/settings/common/views';

import {
  NotificationsSettings,
  NotificationsSettingsForm,
  NotificationsSettingsFormProps,
} from '../components';

export interface NotificationsViewProps extends NotificationsSettingsFormProps {
  loading?: boolean;
  submitLoading?: boolean;
}

export const NotificationsView: FC<NotificationsViewProps> = ({
  submitLoading,
  ...formProps
}) => (
  <SettingsView tabValue="notifications">
    <NotificationsSettingsForm {...formProps}>
      <NotificationsSettings />
      <FormFooter submitLoading={submitLoading} />
    </NotificationsSettingsForm>
  </SettingsView>
);
